import { useGrowthReveal, usePruning } from "../../hooks";

// Adapts reveal animation to scroll phase per design reference Section 03
export default function GrowthSection({ phase = 1, children, style: custom = {}, delay = 0 }) {
  const [ref, visible, config] = useGrowthReveal(phase);
  const [pruneRef, pruneOpacity] = usePruning();

  return (
    <div
      ref={(el) => { ref.current = el; pruneRef.current = el; }}
      style={{
        opacity: visible ? pruneOpacity : 0,
        transform: visible ? "translateY(0)" : `translateY(${config.y}px)`,
        transition: `opacity ${config.dur} ${config.ease} ${delay}s, transform ${config.dur} ${config.ease} ${delay}s`,
        ...custom,
      }}
    >
      {children}
    </div>
  );
}
